import { useHistory, useParams } from 'react-router-dom'

export const useGetPacketOrForm = () => {
  const history = useHistory()
  const { resourceId, packetId } = useParams<{
    resourceId?: string
    packetId?: string
  }>()

  const isPacket = history.location.pathname.includes('packets')

  const packet = isPacket ? packetId : undefined
  const form = !isPacket ? resourceId : undefined

  return { form, packet }
}
